import {createContext} from 'react';
import {ApiLinkedNodeItem} from '../interface';

interface CompassContextInterface {
    isLink: boolean
    item: ApiLinkedNodeItem | null
}

export const CompassContext = createContext<CompassContextInterface>({isLink: false, item: null});
